import bannersMap from './banners-map';

const registerBanner = (bannerType, BannerComponent) => {
  bannersMap.set(bannerType, BannerComponent);
};

export default registerBanner;
